import React from "react";
import { Button, Card, CardBody, Col, Container, Row } from "reactstrap";
import BreadCrumb from "../../Components/Common/BreadCrumb";

const TermsCondition = () => {
  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid>
          <Row className="justify-content-center">
            <Col className="col-lg-10">
              <Card>
                <div className="bg-info-subtle position-relative">
                  <CardBody className="card-body p-5">
                    <div className="text-center">
                      <h3>Términos y Condiciones</h3>
                      <p className="mb-0 text-muted">
                        Última actualización: 16 de septiembre de 2022
                      </p>
                    </div>
                  </CardBody>
                  <div className="shape">
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      version="1.1"
                      xmlnsXlink="http://www.w3.org/1999/xlink"
                      width="100%"
                      height="60"
                      preserveAspectRatio="none"
                      viewBox="0 0 1440 60"
                    >
                      <g mask='url("#SvgjsMask1001")' fill="none">
                        <path
                          d="M 0,4 C 144,13 432,48 720,49 C 1008,50 1296,17 1440,9L1440 60L0 60z"
                          style={{ fill: "var(--vz-secondary-bg)" }}
                        ></path>
                      </g>
                      <defs>
                        <mask id="SvgjsMask1001">
                          <rect width="1440" height="60" fill="#ffffff"></rect>
                        </mask>
                      </defs>
                    </svg>
                  </div>
                </div>
                <CardBody className="card-body p-4">
                  <div>
                    <h5>¡Bienvenido a Velzon!</h5>
                    <p className="text-muted">
                      Estos términos y condiciones describen las reglas y
                      regulaciones para el uso del sitio web de Company Name, ubicado en
                      Website.com.
                    </p>
                    <p className="text-muted">
                      Al acceder a este sitio web, asumimos que aceptas estos términos
                      y condiciones. No continúes usando Website Name si no
                      aceptas todos los términos y condiciones indicados en esta página.
                    </p>
                    <p className="text-muted">
                      La mayoría de los sitios web interactivos usan cookies para permitirnos recuperar
                      los detalles del usuario para cada visita. Las cookies son utilizadas por nuestro
                      sitio web para habilitar la funcionalidad de ciertas áreas y
                      facilitar la visita de las personas a nuestro sitio web. Algunos
                      de nuestros socios afiliados/publicitarios también pueden usar cookies.
                    </p>
                  </div>

                  <div>
                    <h5>Licencia</h5>
                    <p className="text-muted">
                      A menos que se indique lo contrario, Company Name y/o sus licenciantes
                      poseen los derechos de propiedad intelectual de todo el material en
                      Website Name. Todos los derechos de propiedad intelectual están
                      reservados. Puedes acceder a esto desde Website Name para tu
                      uso personal sujeto a las restricciones establecidas en estos
                      términos y condiciones.
                    </p>
                    <p className="text-muted">No debes:</p>
                    <ul className="text-muted vstack gap-2">
                      <li>Republicar material de Website Name</li>
                      <li>
                        Vender, alquilar o sublicenciar material de Website Name
                      </li>
                      <li>
                        Reproducir, duplicar o copiar material de Website Name
                      </li>
                      <li>Redistribuir contenido de Website Name</li>
                    </ul>
                    <p className="text-muted">
                      Este acuerdo comenzará en la fecha del presente.
                    </p>
                    <p className="text-muted">
                      Partes de este sitio web ofrecen la oportunidad para que los usuarios
                      publiquen e intercambien opiniones e información en ciertas
                      áreas del sitio web. Company Name no filtra, edita,
                      publica ni revisa Comentarios antes de su presencia en el
                      sitio web. Los Comentarios no reflejan las opiniones y puntos de vista de
                      Company Name, sus agentes y/o afiliados.
                    </p>
                  </div>

                  <div>
                    <p className="text-muted">
                      Company Name se reserva el derecho de monitorear todos los Comentarios
                      y eliminar cualquier Comentario que pueda considerarse
                      inapropiado, ofensivo o que cause incumplimiento de estos Términos
                      y Condiciones.
                    </p>
                    <p className="text-muted">
                      Garantizas y declaras que:
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>
                        Tienes derecho a publicar los Comentarios en nuestro sitio web y
                        posees todas las licencias y consentimientos necesarios para hacerlo;
                      </li>
                      <li>
                        Los Comentarios no infringen ningún derecho de propiedad intelectual,
                        incluidos, entre otros, los derechos de autor, patentes o
                        marcas comerciales de terceros;
                      </li>
                      <li>
                        Los Comentarios no contienen ningún material difamatorio, calumnioso,
                        ofensivo, indecente o ilegal que sea una invasión de la privacidad
                      </li>
                      <li>
                        Los Comentarios no se utilizarán para solicitar o promover
                        negocios o costumbres ni presentar actividades comerciales o
                        actividades ilegales.
                      </li>
                    </ul>
                    <p className="text-muted">
                      Por la presente, otorgas a Company Name una licencia no exclusiva para
                      usar, reproducir, editar y autorizar a otros a usar,
                      reproducir y editar cualquiera de tus Comentarios en cualquier y todos
                      los formatos, formas o medios.
                    </p>
                    <p className="text-muted">
                      Las organizaciones aprobadas pueden vincularse a nuestro sitio web de la siguiente manera:
                    </p>
                    <ul className="text-muted vstack gap-2">
                      <li>Usando nuestro nombre corporativo; o</li>
                      <li>
                        Usando el localizador uniforme de recursos que se vincula; o
                      </li>
                      <li>
                        Usando cualquier otra descripción de nuestro sitio web que
                        tenga sentido dentro del contexto y formato del contenido
                        en el sitio de la parte vinculante.
                      </li>
                    </ul>
                    <p className="text-muted fw-semibold">
                      No se permitirá el uso del logotipo de Company Name u otra obra de arte
                      para la vinculación sin un acuerdo de licencia de marca registrada.
                    </p>
                  </div>

                  <div className="text-end">
                    <Button className="btn-success">
                      Aceptar
                    </Button>
                    <Button className="btn-outline-danger">
                      <i className="icon-x label-icon"></i>{" "}
                      Rechazar
                    </Button>
                  </div>
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default TermsCondition;
